;(function() {
  'use strict'

  angular.module('core.usage', [])
})()
